var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", {value: true});
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, {get: all[name], enumerable: true});
};

// ../../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}

// ../../../node_modules/react-layout-effect/dist/esm/useLayoutEffect.js
import {
  useEffect,
  useLayoutEffect
} from "react";
var useLayoutEffect2 = typeof window !== "undefined" && window.document && window.document.createElement ? useLayoutEffect : useEffect;

// ../../../node_modules/@react-spring/shared/esm/globals.js
var globals_exports = {};
__export(globals_exports, {
  assign: () => assign,
  batchedUpdates: () => batchedUpdates,
  colorNames: () => colorNames,
  createStringInterpolator: () => createStringInterpolator,
  frameLoop: () => frameLoop,
  now: () => now,
  requestAnimationFrame: () => requestAnimationFrame,
  skipAnimation: () => skipAnimation,
  to: () => to,
  willAdvance: () => willAdvance
});

// ../../../node_modules/@react-spring/shared/esm/FrameLoop.js
var requestAnimationFrame2 = function(fn) {
  return (void 0, requestAnimationFrame)(fn);
};
var FrameLoop = function() {
  function FrameLoop2(raf) {
    if (raf === void 0) {
      raf = requestAnimationFrame2;
    }
    var idle = true;
    var writing = false;
    var lastTime = 0;
    var animations = [];
    var priority = 0;
    var startQueue = new Set();
    var frameQueue = new Set();
    var writeQueue = new Set();
    var start = function(animation) {
      var index = animations.indexOf(animation);
      if (index < 0) {
        index = animations.findIndex(function(other) {
          return other.priority > animation.priority;
        });
        animations.splice(~index ? index : animations.length, 0, animation);
      }
    };
    var loop = function() {
      if (idle)
        return;
      try {
        advance();
        raf(loop);
      } catch (e) {
        console.error(e);
      }
    };
    var kickoff = function() {
      if (idle) {
        idle = false;
        if (lastTime == 0) {
          lastTime = now();
          raf(loop);
        }
      }
    };
    var timeoutQueue = [];
    this.setTimeout = function(handler, ms) {
      var time = now() + ms;
      var cancel = function() {
        var index2 = timeoutQueue.findIndex(function(t) {
          return t.cancel == cancel;
        });
        if (index2 >= 0) {
          timeoutQueue.splice(index2, 1);
        }
      };
      var index = findIndex(timeoutQueue, function(t) {
        return t.time > time;
      });
      var timeout = {time, handler, cancel};
      timeoutQueue.splice(index, 0, timeout);
      kickoff();
      return timeout;
    };
    var advance = this.advance = function() {
      var time = now();
      if (startQueue.size) {
        startQueue.forEach(start);
        startQueue.clear();
      }
      if (timeoutQueue.length) {
        batchedUpdates(function() {
          var count = findIndex(timeoutQueue, function(t) {
            return t.time > time;
          });
          timeoutQueue.splice(0, count).forEach(function(t) {
            return t.handler();
          });
        });
      }
      if (time > lastTime) {
        var dt_1 = Math.min(64, time - lastTime);
        lastTime = time;
        batchedUpdates(function() {
          if (animations.length) {
            willAdvance(animations);
            animations = animations.filter(function(animation) {
              priority = animation.priority;
              if (!animation.idle) {
                animation.advance(dt_1);
              }
              return !animation.idle;
            });
            priority = 0;
          }
          if (frameQueue.size) {
            frameQueue.forEach(function(onFrame) {
              return onFrame(time);
            });
            frameQueue.clear();
          }
          if (writeQueue.size) {
            writing = true;
            writeQueue.forEach(function(write) {
              return write(time);
            });
            writeQueue.clear();
            writing = false;
          }
        });
      }
    };
    this.start = function(animation) {
      if (priority > animation.priority) {
        startQueue.add(animation);
      } else {
        start(animation);
        kickoff();
      }
    };
    this.onFrame = function(cb) {
      frameQueue.add(cb);
      kickoff();
    };
    this.onWrite = function(cb) {
      if (writing)
        cb(lastTime);
      else
        writeQueue.add(cb);
    };
    if (typeof process !== "undefined" && true) {
      var dispose_1 = function() {
        idle = true;
        startQueue.clear();
        timeoutQueue.length = 0;
      };
      Object.defineProperties(this, {
        _animations: {get: function() {
          return animations;
        }},
        _dispose: {get: function() {
          return dispose_1;
        }}
      });
    }
  }
  return FrameLoop2;
}();
function findIndex(arr, test) {
  var index = arr.findIndex(test);
  return index < 0 ? arr.length : index;
}

// ../../../node_modules/@react-spring/shared/esm/helpers.js
var noop = function() {
};
var defineHidden = function(obj, key, value) {
  return Object.defineProperty(obj, key, {value, writable: true, configurable: true});
};
var is = {
  arr: Array.isArray,
  obj: function(a) {
    return !!a && a.constructor.name === "Object";
  },
  fun: function(a) {
    return typeof a === "function";
  },
  str: function(a) {
    return typeof a === "string";
  },
  num: function(a) {
    return typeof a === "number";
  },
  und: function(a) {
    return a === void 0;
  }
};
function isEqual(a, b) {
  if (is.arr(a)) {
    if (!is.arr(b) || a.length !== b.length)
      return false;
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i])
        return false;
    }
    return true;
  }
  return a === b;
}
var isAnimatedString = function(value) {
  return is.str(value) && (value[0] == "#" || /\d/.test(value) || !!(colorNames && colorNames[value]));
};
var each = function(obj, cb, ctx2) {
  if (is.fun(obj.forEach)) {
    obj.forEach(cb, ctx2);
  } else {
    Object.keys(obj).forEach(function(key) {
      return cb.call(ctx2, obj[key], key);
    });
  }
};
var toArray = function(a) {
  return is.und(a) ? [] : is.arr(a) ? a : [a];
};
function flush(queue, iterator) {
  if (queue.size) {
    var items = Array.from(queue);
    queue.clear();
    each(items, iterator);
  }
}

// ../../../node_modules/@react-spring/shared/esm/globals.js
var createStringInterpolator;
var frameLoop = new FrameLoop();
var to;
var now = function() {
  return performance.now();
};
var colorNames = null;
var skipAnimation = false;
var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame : function() {
  return -1;
};
var batchedUpdates = function(callback) {
  return callback();
};
var willAdvance = noop;
var assign = function(globals) {
  var _a;
  return _a = Object.assign({
    to,
    now,
    frameLoop,
    colorNames,
    skipAnimation,
    createStringInterpolator,
    requestAnimationFrame,
    batchedUpdates,
    willAdvance
  }, pluckDefined(globals)), to = _a.to, now = _a.now, frameLoop = _a.frameLoop, colorNames = _a.colorNames, skipAnimation = _a.skipAnimation, createStringInterpolator = _a.createStringInterpolator, requestAnimationFrame = _a.requestAnimationFrame, batchedUpdates = _a.batchedUpdates, willAdvance = _a.willAdvance, _a;
};
function pluckDefined(globals) {
  var defined = {};
  for (var key in globals) {
    if (globals[key] !== void 0)
      defined[key] = globals[key];
  }
  return defined;
}

// ../../../node_modules/@react-spring/shared/esm/hooks.js
import {useEffect as useEffect2, useRef, useState} from "react";
var useOnce = function(effect) {
  return useEffect2(effect, []);
};
var useForceUpdate = function() {
  var update = useState(0)[1];
  var unmounted = useRef(false);
  useOnce(function() {
    return function() {
      unmounted.current = true;
    };
  });
  return function() {
    if (!unmounted.current) {
      update({});
    }
  };
};
function usePrev(value) {
  var prevRef = useRef(void 0);
  useEffect2(function() {
    prevRef.current = value;
  });
  return prevRef.current;
}

// ../../../node_modules/@react-spring/shared/esm/createInterpolator.js
var createInterpolator = function(range, output, extrapolate) {
  if (is.fun(range)) {
    return range;
  }
  if (is.arr(range)) {
    return createInterpolator({
      range,
      output,
      extrapolate
    });
  }
  if (is.str(range.output[0])) {
    return createStringInterpolator(range);
  }
  var config2 = range;
  var outputRange = config2.output;
  var inputRange = config2.range || [0, 1];
  var extrapolateLeft = config2.extrapolateLeft || config2.extrapolate || "extend";
  var extrapolateRight = config2.extrapolateRight || config2.extrapolate || "extend";
  var easing = config2.easing || function(t) {
    return t;
  };
  return function(input) {
    var range2 = findRange(input, inputRange);
    return interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config2.map);
  };
};
function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  var result = map ? map(input) : input;
  if (result < inputMin) {
    if (extrapolateLeft === "identity")
      return result;
    else if (extrapolateLeft === "clamp")
      result = inputMin;
  }
  if (result > inputMax) {
    if (extrapolateRight === "identity")
      return result;
    else if (extrapolateRight === "clamp")
      result = inputMax;
  }
  if (outputMin === outputMax)
    return outputMin;
  if (inputMin === inputMax)
    return input <= inputMin ? outputMin : outputMax;
  if (inputMin === -Infinity)
    result = -result;
  else if (inputMax === Infinity)
    result = result - inputMin;
  else
    result = (result - inputMin) / (inputMax - inputMin);
  result = easing(result);
  if (outputMin === -Infinity)
    result = -result;
  else if (outputMax === Infinity)
    result = result + outputMin;
  else
    result = result * (outputMax - outputMin) + outputMin;
  return result;
}
function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i)
    if (inputRange[i] >= input)
      break;
  return i - 1;
}

// ../../../node_modules/fluids/dist/esm/index.js
var $config = Symbol.for("FluidValue:config");
function getFluidValue(arg) {
  var config2 = getFluidConfig(arg);
  return config2 ? config2.get() : arg;
}
function getFluidConfig(arg) {
  if (arg)
    return arg[$config];
}
function setFluidConfig(target, config2) {
  Object.defineProperty(target, $config, {
    value: config2,
    configurable: true
  });
}
var FluidValue = function() {
  function FluidValue2() {
    setFluidConfig(this, this);
  }
  return FluidValue2;
}();

// ../../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// ../../../node_modules/@react-spring/core/index.js
import {createContext, useContext, createElement as createElement2, useRef as useRef4, useState as useState3, useMemo as useMemo$1, useImperativeHandle, Fragment} from "react";

// ../../../node_modules/@react-spring/animated/index.js
import {forwardRef, useRef as useRef2, createElement} from "react";
var $node = Symbol.for("Animated:node");
var isAnimated = (value) => !!value && value[$node] === value;
var getAnimated = (owner) => owner && owner[$node];
var setAnimated = (owner, node) => defineHidden(owner, $node, node);
var getPayload = (owner) => owner && owner[$node] && owner[$node].getPayload();
var Animated = class {
  constructor() {
    this.payload = void 0;
    setAnimated(this, this);
  }
  getPayload() {
    return this.payload || [];
  }
};
var AnimatedValue = class extends Animated {
  constructor(_value) {
    super();
    this._value = _value;
    this.done = true;
    this.elapsedTime = void 0;
    this.lastPosition = void 0;
    this.lastVelocity = void 0;
    this.v0 = void 0;
    if (is.num(this._value)) {
      this.lastPosition = this._value;
    }
  }
  static create(from, _to) {
    return new AnimatedValue(from);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(value, step) {
    if (is.num(value)) {
      this.lastPosition = value;
      if (step) {
        value = Math.round(value / step) * step;
        if (this.done) {
          this.lastPosition = value;
        }
      }
    }
    if (this._value === value) {
      return false;
    }
    this._value = value;
    return true;
  }
  reset() {
    const {
      done
    } = this;
    this.done = false;
    if (is.num(this._value)) {
      this.elapsedTime = 0;
      this.lastPosition = this._value;
      if (done)
        this.lastVelocity = null;
      this.v0 = null;
    }
  }
};
var AnimatedString = class extends AnimatedValue {
  constructor(from, to2) {
    super(0);
    this._value = void 0;
    this._string = null;
    this._toString = void 0;
    this._toString = createInterpolator({
      output: [from, to2]
    });
  }
  static create(from, to2 = from) {
    if (is.str(from) && is.str(to2)) {
      return new AnimatedString(from, to2);
    }
    throw TypeError('Expected "from" and "to" to be strings');
  }
  getValue() {
    let value = this._string;
    return value == null ? this._string = this._toString(this._value) : value;
  }
  setValue(value) {
    if (!is.num(value)) {
      this._string = value;
      this._value = 1;
    } else if (super.setValue(value)) {
      this._string = null;
    } else {
      return false;
    }
    return true;
  }
  reset(goal) {
    if (goal) {
      this._toString = createInterpolator({
        output: [this.getValue(), goal]
      });
    }
    this._value = 0;
    super.reset();
  }
};
var TreeContext = {
  current: null
};
var AnimatedObject = class extends Animated {
  constructor(source = null) {
    super();
    this.source = void 0;
    this.setValue(source);
  }
  getValue(animated2) {
    if (!this.source)
      return null;
    const values = {};
    each(this.source, (source, key) => {
      if (isAnimated(source)) {
        values[key] = source.getValue(animated2);
      } else {
        const config2 = getFluidConfig(source);
        if (config2) {
          values[key] = config2.get();
        } else if (!animated2) {
          values[key] = source;
        }
      }
    });
    return values;
  }
  setValue(source) {
    this.source = source;
    this.payload = this._makePayload(source);
  }
  reset() {
    if (this.payload) {
      each(this.payload, (node) => node.reset());
    }
  }
  _makePayload(source) {
    if (source) {
      const payload = new Set();
      each(source, this._addToPayload, payload);
      return Array.from(payload);
    }
  }
  _addToPayload(source) {
    const config2 = getFluidConfig(source);
    if (config2 && TreeContext.current) {
      TreeContext.current.dependencies.add(source);
    }
    const payload = getPayload(source);
    if (payload) {
      each(payload, (node) => this.add(node));
    }
  }
};
var AnimatedArray = class extends AnimatedObject {
  constructor(from, to2) {
    super(null);
    this.source = void 0;
    super.setValue(this._makeAnimated(from, to2));
  }
  static create(from, to2) {
    return new AnimatedArray(from, to2);
  }
  getValue() {
    return this.source.map((node) => node.getValue());
  }
  setValue(newValue) {
    const payload = this.getPayload();
    if (newValue && newValue.length == payload.length) {
      each(payload, (node, i) => node.setValue(newValue[i]));
    } else {
      this.source = this._makeAnimated(newValue);
      this.payload = this._makePayload(this.source);
    }
  }
  _makeAnimated(from, to2 = from) {
    return from ? from.map((from2, i) => (isAnimatedString(from2) ? AnimatedString : AnimatedValue).create(from2, to2[i])) : [];
  }
};
var AnimatedProps = class extends AnimatedObject {
  constructor(update) {
    super(null);
    this.update = update;
    this.dirty = false;
  }
  setValue(props, context) {
    if (!props)
      return;
    if (context) {
      TreeContext.current = context;
      if (props.style) {
        const {
          createAnimatedStyle
        } = context.host;
        props = _extends(_extends({}, props), {}, {
          style: createAnimatedStyle(props.style)
        });
      }
    }
    super.setValue(props);
    TreeContext.current = null;
  }
  onParentChange({
    type
  }) {
    if (!this.dirty && type === "change") {
      this.dirty = true;
      frameLoop.onFrame(() => {
        this.dirty = false;
        this.update();
      });
    }
  }
};
var withAnimated = (Component, host2) => forwardRef((rawProps, ref) => {
  const instanceRef = useRef2(null);
  const hasInstance = !is.fun(Component) || Component.prototype && Component.prototype.isReactComponent;
  const forceUpdate = useForceUpdate();
  const props = new AnimatedProps(() => {
    const instance = instanceRef.current;
    if (hasInstance && !instance) {
      return;
    }
    const didUpdate = instance ? host2.applyAnimatedValues(instance, props.getValue(true)) : false;
    if (didUpdate === false) {
      forceUpdate();
    }
  });
  const dependencies = new Set();
  props.setValue(rawProps, {
    dependencies,
    host: host2
  });
  useLayoutEffect2(() => {
    each(dependencies, (dep) => dep.addChild(props));
    return () => each(dependencies, (dep) => dep.removeChild(props));
  });
  return /* @__PURE__ */ createElement(Component, _extends({}, host2.getComponentProps(props.getValue()), {
    ref: hasInstance && ((value) => {
      instanceRef.current = updateRef(ref, value);
    })
  }));
});
function updateRef(ref, value) {
  if (ref) {
    if (is.fun(ref))
      ref(value);
    else
      ref.current = value;
  }
  return value;
}
var cacheKey = Symbol.for("AnimatedComponent");
var createHost = (components, {
  applyAnimatedValues: applyAnimatedValues2 = () => false,
  createAnimatedStyle = (style) => new AnimatedObject(style),
  getComponentProps = (props) => props
} = {}) => {
  const hostConfig = {
    applyAnimatedValues: applyAnimatedValues2,
    createAnimatedStyle,
    getComponentProps
  };
  const animated2 = (Component) => {
    const displayName = getDisplayName(Component) || "Anonymous";
    if (is.str(Component)) {
      Component = withAnimated(Component, hostConfig);
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }
    Component.displayName = "Animated(" + displayName + ")";
    return Component;
  };
  each(components, (Component, key) => {
    if (!is.str(key)) {
      key = getDisplayName(Component);
    }
    animated2[key] = animated2(Component);
  });
  return {
    animated: animated2
  };
};
var getDisplayName = (arg) => is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;

// ../../../node_modules/use-memo-one/dist/use-memo-one.esm.js
import {useState as useState2, useRef as useRef3, useEffect as useEffect3} from "react";
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }
  return true;
}
function useMemoOne(getResult, inputs) {
  var initial = useState2(function() {
    return {
      inputs,
      result: getResult()
    };
  })[0];
  var committed = useRef3(initial);
  var isInputMatch = Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
  var cache = isInputMatch ? committed.current : {
    inputs,
    result: getResult()
  };
  useEffect3(function() {
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
function useCallbackOne(callback, inputs) {
  return useMemoOne(function() {
    return callback;
  }, inputs);
}

// ../../../node_modules/@react-spring/shared/esm/deprecations.js
var prefix = "react-spring: ";
var flagInterpolate = false;
function deprecateInterpolate() {
  if (!flagInterpolate) {
    flagInterpolate = true;
    console.warn(prefix + 'The "interpolate" function is deprecated in v10 (use "to" instead)');
  }
}

// ../../../node_modules/@react-spring/shared/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};

// ../../../node_modules/@react-spring/shared/esm/colorMatchers.js
var NUMBER = "[-+]?\\d*\\.?\\d+";
var PERCENTAGE = NUMBER + "%";
function call() {
  var parts = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    parts[_i] = arguments[_i];
  }
  return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var rgb = new RegExp("rgb" + call(NUMBER, NUMBER, NUMBER));
var rgba = new RegExp("rgba" + call(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl = new RegExp("hsl" + call(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla = new RegExp("hsla" + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/;

// ../../../node_modules/@react-spring/shared/esm/normalizeColor.js
function normalizeColor(color) {
  var match;
  if (typeof color === "number") {
    return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
  }
  if (match = hex6.exec(color))
    return parseInt(match[1] + "ff", 16) >>> 0;
  if (colorNames && colorNames[color] !== void 0) {
    return colorNames[color];
  }
  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | 255) >>> 0;
  }
  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | parse1(match[4])) >>> 0;
  }
  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
  }
  if (match = hex8.exec(color))
    return parseInt(match[1], 16) >>> 0;
  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
  }
  if (match = hsl.exec(color)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | 255) >>> 0;
  }
  if (match = hsla.exec(color)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | parse1(match[4])) >>> 0;
  }
  return null;
}
function hue2rgb(h, c, x) {
  if (h < 60)
    return [c, x, 0];
  if (h < 120)
    return [x, c, 0];
  if (h < 180)
    return [0, c, x];
  if (h < 240)
    return [0, x, c];
  if (h < 300)
    return [x, 0, c];
  return [c, 0, x];
}
function hslToRgb(h, s, l) {
  var C = (1 - Math.abs(2 * l - 1)) * s;
  var X = C * (1 - Math.abs(h / 60 % 2 - 1));
  var M = l - C / 2;
  var _a = hue2rgb(h, C, X), R1 = _a[0], G1 = _a[1], B1 = _a[2];
  return Math.round((R1 + M) * 255) << 24 | Math.round((G1 + M) * 255) << 16 | Math.round((B1 + M) * 255) << 8;
}
function parse255(str) {
  var int = parseInt(str, 10);
  if (int < 0)
    return 0;
  if (int > 255)
    return 255;
  return int;
}
function parse360(str) {
  var int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}
function parse1(str) {
  var num = parseFloat(str);
  if (num < 0)
    return 0;
  if (num > 1)
    return 255;
  return Math.round(num * 255);
}
function parsePercentage(str) {
  var int = parseFloat(str);
  if (int < 0)
    return 0;
  if (int > 100)
    return 1;
  return int / 100;
}

// ../../../node_modules/@react-spring/shared/esm/colorToRgba.js
function colorToRgba(input) {
  var int32Color = normalizeColor(input);
  if (int32Color === null)
    return input;
  int32Color = int32Color || 0;
  var r = (int32Color & 4278190080) >>> 24;
  var g = (int32Color & 16711680) >>> 16;
  var b = (int32Color & 65280) >>> 8;
  var a = (int32Color & 255) / 255;
  return "rgba(" + r + ", " + g + ", " + b + ", " + a + ")";
}

// ../../../node_modules/@react-spring/shared/esm/stringInterpolation.js
var numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var colorNamesRegex;
var rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var rgbaRound = function(_, p1, p2, p3, p4) {
  return "rgba(" + Math.round(p1) + ", " + Math.round(p2) + ", " + Math.round(p3) + ", " + p4 + ")";
};
var createStringInterpolator2 = function(config2) {
  if (!colorNamesRegex)
    colorNamesRegex = colorNames ? new RegExp("(" + Object.keys(colorNames).join("|") + ")", "g") : /^\b$/;
  var output = config2.output.map(function(value) {
    return getFluidValue(value).replace(colorRegex, colorToRgba).replace(colorNamesRegex, colorToRgba);
  });
  var keyframes = output.map(function(value) {
    return value.match(numberRegex).map(Number);
  });
  var outputRanges = keyframes[0].map(function(_, i) {
    return keyframes.map(function(values) {
      if (!(i in values)) {
        throw Error('The arity of each "output" value must be equal');
      }
      return values[i];
    });
  });
  var interpolators = outputRanges.map(function(output2) {
    return createInterpolator(__assign(__assign({}, config2), {output: output2}));
  });
  return function(input) {
    var i = 0;
    return output[0].replace(numberRegex, function() {
      return String(interpolators[i++](input));
    }).replace(rgbaRegex, rgbaRound);
  };
};

// ../../../node_modules/@react-spring/core/index.js
function useChain(refs, timeSteps, timeFrame = 1e3) {
  useLayoutEffect2(() => {
    if (timeSteps) {
      let prevDelay = 0;
      each(refs, (ref, i) => {
        if (!ref.current)
          return;
        const {
          controllers
        } = ref.current;
        if (controllers.length) {
          let delay = timeFrame * timeSteps[i];
          if (isNaN(delay))
            delay = prevDelay;
          else
            prevDelay = delay;
          each(controllers, (ctrl) => {
            each(ctrl.queue, (props) => {
              props.delay = delay + (props.delay || 0);
            });
            ctrl.start();
          });
        }
      });
    } else {
      let p = Promise.resolve();
      each(refs, (ref) => {
        const {
          controllers,
          start
        } = ref.current || {};
        if (controllers && controllers.length) {
          const updates = controllers.map((ctrl) => {
            const q = ctrl.queue;
            ctrl.queue = [];
            return q;
          });
          p = p.then(() => {
            each(controllers, (ctrl, i) => ctrl.queue.push(...updates[i]));
            return start();
          });
        }
      });
    }
  });
}
var config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};
var linear = (t) => t;
var defaults = _extends(_extends({}, config.default), {}, {
  mass: 1,
  damping: 1,
  easing: linear,
  clamp: false
});
var AnimationConfig = class {
  constructor() {
    this.tension = void 0;
    this.friction = void 0;
    this.frequency = void 0;
    this.damping = void 0;
    this.mass = void 0;
    this.velocity = 0;
    this.restVelocity = void 0;
    this.precision = void 0;
    this.progress = void 0;
    this.duration = void 0;
    this.easing = void 0;
    this.clamp = void 0;
    this.bounce = void 0;
    this.decay = void 0;
    this.round = void 0;
    Object.assign(this, defaults);
  }
};
function mergeConfig(config2, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = _extends({}, defaultConfig);
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = _extends(_extends({}, defaultConfig), newConfig);
  }
  sanitizeConfig(config2, newConfig);
  Object.assign(config2, newConfig);
  for (const key in defaults) {
    if (config2[key] == null) {
      config2[key] = defaults[key];
    }
  }
  let {
    mass,
    frequency,
    damping
  } = config2;
  if (!is.und(frequency)) {
    if (frequency < 0.01)
      frequency = 0.01;
    if (damping < 0)
      damping = 0;
    config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config2.friction = 4 * Math.PI * damping * mass / frequency;
  }
  return config2;
}
function sanitizeConfig(config2, props) {
  if (!is.und(props.decay)) {
    config2.duration = void 0;
  } else {
    const isTensionConfig = !is.und(props.tension) || !is.und(props.friction);
    if (isTensionConfig || !is.und(props.frequency) || !is.und(props.damping) || !is.und(props.mass)) {
      config2.duration = void 0;
      config2.decay = void 0;
    }
    if (isTensionConfig) {
      config2.frequency = void 0;
    }
  }
}
var emptyArray = [];
var Animation = class {
  constructor() {
    this.changed = false;
    this.values = emptyArray;
    this.toValues = null;
    this.fromValues = emptyArray;
    this.to = void 0;
    this.from = void 0;
    this.config = new AnimationConfig();
    this.immediate = false;
    this.onStart = void 0;
    this.onChange = void 0;
    this.onRest = [];
  }
};
var useMemo = (create, deps) => useMemoOne(create, deps || [{}]);
function callProp(value, ...args) {
  return is.fun(value) ? value(...args) : value;
}
var matchProp = (value, key) => value === true || !!(key && value && (is.fun(value) ? value(key) : toArray(value).includes(key)));
var getProps = (props, i, arg) => props && (is.fun(props) ? props(i, arg) : is.arr(props) ? props[i] : _extends({}, props));
var hasDefaultProp = (props, key) => !is.und(getDefaultProp(props, key));
var getDefaultProp = (props, key) => props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var getDefaultProps = (props, omitKeys = [], defaults2 = {}) => {
  let keys = DEFAULT_PROPS;
  if (props.default && props.default !== true) {
    props = props.default;
    keys = Object.keys(props);
  }
  for (const key of keys) {
    const value = props[key];
    if (!is.und(value) && !omitKeys.includes(key)) {
      defaults2[key] = value;
    }
  }
  return defaults2;
};
var mergeDefaultProps = (defaults2, props, omitKeys) => getDefaultProps(props, omitKeys, defaults2);
var DEFAULT_PROPS = ["pause", "cancel", "config", "immediate", "onDelayEnd", "onProps", "onStart", "onChange", "onRest"];
var RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onDelayEnd: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onRest: 1,
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  keys: 1,
  callId: 1,
  parentId: 1
};
function getForwardProps(props) {
  const forward = {};
  let count = 0;
  each(props, (value, prop) => {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });
  if (count) {
    return forward;
  }
}
function inferTo(props) {
  const to2 = getForwardProps(props);
  if (to2) {
    const out = {
      to: to2
    };
    each(props, (val, key) => key in to2 || (out[key] = val));
    return out;
  }
  return _extends({}, props);
}
function computeGoal(value) {
  const config2 = getFluidConfig(value);
  return config2 ? computeGoal(config2.get()) : is.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}
function scheduleProps(callId, {
  key,
  props,
  state,
  actions
}) {
  return new Promise((resolve, reject) => {
    let delay;
    let timeout;
    let pause = false;
    let cancel = matchProp(props.cancel, key);
    if (cancel) {
      onStart();
    } else {
      delay = callProp(props.delay || 0, key);
      pause = matchProp(props.pause, key);
      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }
    function onPause() {
      state.resumeQueue.add(onResume);
      timeout.cancel();
      delay = timeout.time - globals_exports.now();
    }
    function onResume() {
      if (delay > 0) {
        state.pauseQueue.add(onPause);
        timeout = globals_exports.frameLoop.setTimeout(onStart, delay);
      } else {
        onStart();
      }
    }
    function onStart() {
      state.pauseQueue.delete(onPause);
      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }
      try {
        actions.start(_extends(_extends({}, props), {}, {
          callId,
          delay,
          cancel,
          pause
        }), resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}
var getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some((result) => result.cancelled) ? getCancelledResult(target) : results.every((result) => result.noop) ? getNoopResult(target) : getFinishedResult(target, results.every((result) => result.finished));
var getNoopResult = (target, value = target.get()) => ({
  value,
  noop: true,
  finished: true,
  target
});
var getFinishedResult = (target, finished, value = target.get()) => ({
  value,
  finished,
  target
});
var getCancelledResult = (target, value = target.get()) => ({
  value,
  cancelled: true,
  target
});
async function runAsync(to2, props, state, target) {
  if (props.pause) {
    await new Promise((resume) => {
      state.resumeQueue.add(resume);
    });
  }
  const {
    callId,
    parentId,
    onRest
  } = props;
  const {
    asyncTo: prevTo,
    promise: prevPromise
  } = state;
  if (!parentId && to2 === prevTo && !props.reset) {
    return prevPromise;
  }
  return state.promise = (async () => {
    state.asyncId = callId;
    state.asyncTo = to2;
    const defaultProps = getDefaultProps(props, [
      "onRest"
    ]);
    let preventBail;
    let bail;
    const bailPromise = new Promise((resolve, reject) => (preventBail = resolve, bail = reject));
    const withBailHandler = (fn) => (...args) => {
      const onError = (err) => {
        if (err instanceof BailSignal) {
          bail(err);
        }
        throw err;
      };
      try {
        return fn(...args).catch(onError);
      } catch (err) {
        onError(err);
      }
    };
    const bailIfEnded = (bailSignal) => {
      const bailResult = callId <= (state.cancelId || 0) && getCancelledResult(target) || callId !== state.asyncId && getFinishedResult(target, false);
      if (bailResult) {
        bailSignal.result = bailResult;
        throw bailSignal;
      }
    };
    const animate = withBailHandler((arg1, arg2) => {
      const bailSignal = new BailSignal();
      bailIfEnded(bailSignal);
      const props2 = is.obj(arg1) ? _extends({}, arg1) : _extends(_extends({}, arg2), {}, {
        to: arg1
      });
      props2.parentId = callId;
      each(defaultProps, (value, key) => {
        if (is.und(props2[key])) {
          props2[key] = value;
        }
      });
      return target.start(props2).then(async (result2) => {
        bailIfEnded(bailSignal);
        if (target.is("PAUSED")) {
          await new Promise((resume) => {
            state.resumeQueue.add(resume);
          });
        }
        return result2;
      });
    });
    let result;
    try {
      let animating;
      if (is.arr(to2)) {
        animating = (async (queue) => {
          for (const props2 of queue) {
            await animate(props2);
          }
        })(to2);
      } else if (is.fun(to2)) {
        animating = Promise.resolve(to2(animate, target.stop.bind(target)));
      }
      await Promise.all([animating.then(preventBail), bailPromise]);
      result = getFinishedResult(target, true);
    } catch (err) {
      if (err instanceof BailSignal) {
        result = err.result;
      } else {
        throw err;
      }
    } finally {
      if (callId == state.asyncId) {
        state.asyncId = parentId;
        state.asyncTo = parentId ? prevTo : void 0;
        state.promise = parentId ? prevPromise : void 0;
      }
    }
    if (is.fun(onRest)) {
      batchedUpdates(() => {
        onRest(result);
      });
    }
    return result;
  })();
}
function cancelAsync(state, callId) {
  state.cancelId = callId;
  state.asyncId = state.asyncTo = state.promise = void 0;
}
var BailSignal = class extends Error {
  constructor() {
    super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    this.result = void 0;
  }
};
var isFrameValue = (value) => value instanceof FrameValue;
var nextId = 1;
var FrameValue = class extends FluidValue {
  constructor(...args) {
    super(...args);
    this.id = nextId++;
    this.key = void 0;
    this._priority = 0;
    this._children = new Set();
  }
  get priority() {
    return this._priority;
  }
  set priority(priority) {
    if (this._priority != priority) {
      this._priority = priority;
      this._onPriorityChange(priority);
    }
  }
  get() {
    const node = getAnimated(this);
    return node && node.getValue();
  }
  to(...args) {
    return to(this, args);
  }
  interpolate(...args) {
    deprecateInterpolate();
    return to(this, args);
  }
  addChild(child) {
    if (!this._children.size)
      this._attach();
    this._children.add(child);
  }
  removeChild(child) {
    this._children.delete(child);
    if (!this._children.size)
      this._detach();
  }
  onParentChange({
    type
  }) {
    if (this.idle) {
      if (type == "start") {
        this._reset();
        this._start();
      }
    } else if (type == "reset") {
      this._reset();
    }
  }
  _attach() {
  }
  _detach() {
  }
  _reset() {
    this._emit({
      type: "reset",
      parent: this
    });
  }
  _start() {
    this._emit({
      type: "start",
      parent: this
    });
  }
  _onChange(value, idle = false) {
    this._emit({
      type: "change",
      parent: this,
      value,
      idle
    });
  }
  _onPriorityChange(priority) {
    if (!this.idle) {
      frameLoop.start(this);
    }
    this._emit({
      type: "priority",
      parent: this,
      priority
    });
  }
  _emit(event) {
    each(Array.from(this._children), (child) => {
      child.onParentChange(event);
    });
  }
};
var CREATED = "CREATED";
var IDLE = "IDLE";
var ACTIVE = "ACTIVE";
var PAUSED = "PAUSED";
var DISPOSED = "DISPOSED";
var SpringValue = class extends FrameValue {
  constructor(arg1, arg2) {
    super();
    this.key = void 0;
    this.animation = new Animation();
    this.queue = void 0;
    this._phase = CREATED;
    this._state = {
      pauseQueue: new Set(),
      resumeQueue: new Set()
    };
    this._defaultProps = {};
    this._lastCallId = 0;
    this._lastToId = 0;
    if (!is.und(arg1) || !is.und(arg2)) {
      const props = is.obj(arg1) ? _extends({}, arg1) : _extends(_extends({}, arg2), {}, {
        from: arg1
      });
      props.default = true;
      this.start(props);
    }
  }
  get idle() {
    return !this.is(ACTIVE) && !this._state.asyncTo;
  }
  get goal() {
    return getFluidValue(this.animation.to);
  }
  get velocity() {
    const node = getAnimated(this);
    return node instanceof AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map((node2) => node2.lastVelocity || 0);
  }
  advance(dt) {
    let idle = true;
    let changed = false;
    const anim = this.animation;
    let {
      config: config2,
      toValues
    } = anim;
    const payload = getPayload(anim.to);
    if (!payload) {
      const toConfig = getFluidConfig(anim.to);
      if (toConfig) {
        toValues = toArray(toConfig.get());
      }
    }
    anim.values.forEach((node, i) => {
      if (node.done)
        return;
      let to2 = payload ? payload[i].lastPosition : toValues[i];
      let finished = anim.immediate;
      let position = to2;
      if (!finished) {
        position = node.lastPosition;
        if (config2.tension <= 0) {
          node.done = true;
          return;
        }
        const elapsed = node.elapsedTime += dt;
        const from = anim.fromValues[i];
        const v0 = node.v0 != null ? node.v0 : node.v0 = is.arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
        let velocity;
        if (!is.und(config2.duration)) {
          let p = config2.progress || 0;
          if (config2.duration <= 0)
            p = 1;
          else
            p += (1 - p) * Math.min(1, elapsed / config2.duration);
          position = from + config2.easing(p) * (to2 - from);
          velocity = (position - node.lastPosition) / dt;
          finished = p == 1;
        } else if (config2.decay) {
          const decay = config2.decay === true ? 0.998 : config2.decay;
          const e = Math.exp(-(1 - decay) * elapsed);
          position = from + v0 / (1 - decay) * (1 - e);
          finished = Math.abs(node.lastPosition - position) < 0.1;
          velocity = v0 * e;
        } else {
          velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
          const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
          const restVelocity = config2.restVelocity || precision / 10;
          const bounceFactor = config2.clamp ? 0 : config2.bounce;
          const canBounce = !is.und(bounceFactor);
          const isGrowing = from == to2 ? node.v0 > 0 : from < to2;
          let isMoving;
          let isBouncing = false;
          const step = 1;
          const numSteps = Math.ceil(dt / step);
          for (let n = 0; n < numSteps; ++n) {
            isMoving = Math.abs(velocity) > restVelocity;
            if (!isMoving) {
              finished = Math.abs(to2 - position) <= precision;
              if (finished) {
                break;
              }
            }
            if (canBounce) {
              isBouncing = position == to2 || position > to2 == isGrowing;
              if (isBouncing) {
                velocity = -velocity * bounceFactor;
                position = to2;
              }
            }
            const springForce = -config2.tension * 1e-6 * (position - to2);
            const dampingForce = -config2.friction * 1e-3 * velocity;
            const acceleration = (springForce + dampingForce) / config2.mass;
            velocity = velocity + acceleration * step;
            position = position + velocity * step;
          }
        }
        node.lastVelocity = velocity;
        if (Number.isNaN(position)) {
          console.warn("Got NaN while animating:", this);
          finished = true;
        }
      }
      if (payload && !payload[i].done) {
        finished = false;
      }
      if (finished) {
        node.done = true;
      } else {
        idle = false;
      }
      if (node.setValue(position, config2.round)) {
        changed = true;
      }
    });
    if (idle) {
      this.finish();
    } else if (changed) {
      this._onChange(this.get());
    }
    return idle;
  }
  is(phase) {
    return this._phase == phase;
  }
  set(value) {
    batchedUpdates(() => {
      this._focus(value);
      if (this._set(value)) {
        if (!this.is(ACTIVE)) {
          return this._onChange(this.get(), true);
        }
      }
      this._stop();
    });
    return this;
  }
  pause() {
    checkDisposed(this, "pause");
    if (!this.is(PAUSED)) {
      this._phase = PAUSED;
      flush(this._state.pauseQueue, (onPause) => onPause());
    }
  }
  resume() {
    checkDisposed(this, "resume");
    if (this.is(PAUSED)) {
      this._start();
      flush(this._state.resumeQueue, (onResume) => onResume());
    }
  }
  finish(to2) {
    this.resume();
    if (this.is(ACTIVE)) {
      const anim = this.animation;
      if (!anim.config.decay && is.und(to2)) {
        to2 = anim.to;
      }
      if (!is.und(to2)) {
        this._set(to2);
      }
      batchedUpdates(() => {
        if (!anim.changed) {
          anim.changed = true;
          if (anim.onStart) {
            anim.onStart(this);
          }
        }
        this._stop();
      });
    }
    return this;
  }
  update(props) {
    checkDisposed(this, "update");
    const queue = this.queue || (this.queue = []);
    queue.push(props);
    return this;
  }
  async start(to2, arg2) {
    checkDisposed(this, "start");
    let queue;
    if (!is.und(to2)) {
      queue = [is.obj(to2) ? to2 : _extends(_extends({}, arg2), {}, {
        to: to2
      })];
    } else {
      queue = this.queue || [];
      this.queue = [];
    }
    const results = await Promise.all(queue.map((props) => this._update(props)));
    return getCombinedResult(this, results);
  }
  stop(cancel) {
    if (!this.is(DISPOSED)) {
      cancelAsync(this._state, this._lastCallId);
      this._focus(this.get());
      batchedUpdates(() => this._stop(cancel));
    }
    return this;
  }
  reset() {
    this._update({
      reset: true
    });
  }
  dispose() {
    if (!this.is(DISPOSED)) {
      if (this.animation) {
        this.animation.onRest = [];
      }
      this.stop();
      this._phase = DISPOSED;
    }
  }
  onParentChange(event) {
    super.onParentChange(event);
    if (event.type == "change") {
      if (!this.is(ACTIVE)) {
        this._reset();
        if (!this.is(PAUSED)) {
          this._start();
        }
      }
    } else if (event.type == "priority") {
      this.priority = event.priority + 1;
    }
  }
  _prepareNode({
    to: to2,
    from,
    reverse
  }) {
    const key = this.key || "";
    to2 = !is.obj(to2) || getFluidConfig(to2) ? to2 : to2[key];
    from = !is.obj(from) || getFluidConfig(from) ? from : from[key];
    const range = {
      to: to2,
      from
    };
    if (this.is(CREATED)) {
      if (reverse)
        [to2, from] = [from, to2];
      from = getFluidValue(from);
      const node = this._updateNode(is.und(from) ? getFluidValue(to2) : from);
      if (node && !is.und(from)) {
        node.setValue(from);
      }
    }
    return range;
  }
  _updateNode(value) {
    let node = getAnimated(this);
    if (!is.und(value)) {
      const nodeType = this._getNodeType(value);
      if (!node || node.constructor !== nodeType) {
        setAnimated(this, node = nodeType.create(value));
      }
    }
    return node;
  }
  _getNodeType(value) {
    const parentNode = getAnimated(value);
    return parentNode ? parentNode.constructor : is.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
  }
  _update(props, isLoop) {
    const defaultProps = this._defaultProps;
    const mergeDefaultProp = (key) => {
      const value = getDefaultProp(props, key);
      if (!is.und(value)) {
        defaultProps[key] = value;
      }
      if (defaultProps[key]) {
        props[key] = defaultProps[key];
      }
    };
    mergeDefaultProp("cancel");
    mergeDefaultProp("pause");
    const range = this._prepareNode(props);
    return scheduleProps(++this._lastCallId, {
      key: this.key,
      props,
      state: this._state,
      actions: {
        pause: this.pause.bind(this),
        resume: this.resume.bind(this),
        start: this._merge.bind(this, range)
      }
    }).then((result) => {
      if (props.loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = createLoopUpdate(props);
        if (nextProps) {
          return this._update(nextProps, true);
        }
      }
      return result;
    });
  }
  _merge(range, props, resolve) {
    if (props.cancel) {
      this.stop(true);
      return resolve(getCancelledResult(this));
    }
    const {
      key,
      animation: anim
    } = this;
    const defaultProps = this._defaultProps;
    const hasToProp = !is.und(range.to);
    const hasFromProp = !is.und(range.from);
    if (hasToProp || hasFromProp) {
      if (props.callId > this._lastToId) {
        this._lastToId = props.callId;
      } else {
        return resolve(getCancelledResult(this));
      }
    }
    const get = (prop) => !is.und(props[prop]) ? props[prop] : defaultProps[prop];
    const onDelayEnd = coerceEventProp(get("onDelayEnd"), key);
    if (onDelayEnd) {
      onDelayEnd(props, this);
    }
    if (props.default) {
      mergeDefaultProps(defaultProps, props, ["pause", "cancel"]);
    }
    const {
      to: prevTo,
      from: prevFrom
    } = anim;
    let {
      to: to2 = prevTo,
      from = prevFrom
    } = range;
    if (hasFromProp && !hasToProp) {
      to2 = from;
    }
    if (props.reverse)
      [to2, from] = [from, to2];
    const hasFromChanged = !isEqual(from, prevFrom);
    if (hasFromChanged) {
      anim.from = from;
    }
    const hasToChanged = !isEqual(to2, prevTo);
    if (hasToChanged) {
      this._focus(to2);
    }
    const toConfig = getFluidConfig(to2);
    const fromConfig = getFluidConfig(from);
    if (fromConfig) {
      from = fromConfig.get();
    }
    const hasAsyncTo = is.arr(props.to) || is.fun(props.to);
    const {
      config: config2
    } = anim;
    const {
      decay,
      velocity
    } = config2;
    if (props.config && !hasAsyncTo) {
      mergeConfig(config2, callProp(props.config, key), props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
    }
    let node = getAnimated(this);
    if (!node || is.und(to2)) {
      return resolve(getFinishedResult(this, true));
    }
    const reset = is.und(props.reset) ? hasFromProp && !props.default : !is.und(from) && matchProp(props.reset, key);
    const value = reset ? from : this.get();
    const goal = computeGoal(to2);
    const isAnimatable = is.num(goal) || is.arr(goal) || isAnimatedString(goal);
    const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));
    if (hasToChanged) {
      if (immediate) {
        node = this._updateNode(goal);
      } else {
        const nodeType = this._getNodeType(to2);
        if (nodeType !== node.constructor) {
          throw Error("Cannot animate between " + node.constructor.name + " and " + nodeType.name + ', as the "to" prop suggests');
        }
      }
    }
    const goalType = node.constructor;
    let started = !!toConfig;
    let finished = false;
    if (!started) {
      const hasValueChanged = reset || this.is(CREATED) && hasFromChanged;
      if (hasToChanged || hasValueChanged) {
        finished = isEqual(computeGoal(value), goal);
        started = !finished;
      }
      if (!isEqual(config2.decay, decay) || !isEqual(config2.velocity, velocity)) {
        started = true;
      }
    }
    if (finished && this.is(ACTIVE)) {
      if (anim.changed && !reset) {
        started = true;
      } else if (!started) {
        this._stop();
      }
    }
    if (!hasAsyncTo) {
      if (started || getFluidConfig(prevTo)) {
        anim.values = node.getPayload();
        anim.toValues = toConfig ? null : goalType == AnimatedString ? [1] : toArray(goal);
      }
      anim.immediate = immediate;
      anim.onStart = coerceEventProp(get("onStart"), key);
      anim.onChange = coerceEventProp(get("onChange"), key);
      const onRestQueue = anim.onRest;
      const onRest = reset && !props.onRest ? onRestQueue[0] || noop : checkFinishedOnRest(coerceEventProp(get("onRest"), key), this);
      if (started) {
        anim.onRest = [onRest, checkFinishedOnRest(resolve, this)];
        let onRestIndex = reset ? 0 : 1;
        if (onRestIndex < onRestQueue.length) {
          batchedUpdates(() => {
            for (; onRestIndex < onRestQueue.length; onRestIndex++) {
              onRestQueue[onRestIndex]();
            }
          });
        }
      } else if (reset || props.onRest) {
        anim.onRest[0] = onRest;
      }
    }
    const onProps = coerceEventProp(get("onProps"), key);
    if (onProps) {
      onProps(props, this);
    }
    if (reset) {
      node.setValue(value);
    }
    if (hasAsyncTo) {
      resolve(runAsync(props.to, props, this._state, this));
    } else if (started) {
      if (reset)
        this._phase = IDLE;
      this._reset();
      this._start();
    } else if (this.is(ACTIVE) && !hasToChanged) {
      anim.onRest.push(checkFinishedOnRest(resolve, this));
    } else {
      resolve(getNoopResult(this, value));
    }
  }
  _focus(value) {
    const anim = this.animation;
    if (value !== anim.to) {
      let config2 = getFluidConfig(anim.to);
      if (config2) {
        config2.removeChild(this);
      }
      anim.to = value;
      let priority = 0;
      if (config2 = getFluidConfig(value)) {
        config2.addChild(this);
        if (isFrameValue(value)) {
          priority = (value.priority || 0) + 1;
        }
      }
      this.priority = priority;
    }
  }
  _set(value) {
    const config2 = getFluidConfig(value);
    if (config2) {
      value = config2.get();
    }
    const node = getAnimated(this);
    const oldValue = node && node.getValue();
    if (node) {
      node.setValue(value);
    } else {
      this._updateNode(value);
    }
    return !isEqual(value, oldValue);
  }
  _onChange(value, idle = false) {
    const anim = this.animation;
    if (!anim.changed && !idle) {
      anim.changed = true;
      if (anim.onStart) {
        anim.onStart(this);
      }
    }
    if (anim.onChange) {
      anim.onChange(value, this);
    }
    super._onChange(value, idle);
  }
  _reset() {
    const anim = this.animation;
    getAnimated(this).reset(anim.to);
    if (!this.is(ACTIVE)) {
      anim.changed = false;
    }
    if (!anim.immediate) {
      anim.fromValues = anim.values.map((node) => node.lastPosition);
    }
    super._reset();
  }
  _start() {
    if (!this.is(ACTIVE)) {
      this._phase = ACTIVE;
      super._start();
      if (skipAnimation) {
        this.finish();
      } else {
        frameLoop.start(this);
      }
    }
  }
  _stop(cancel) {
    this.resume();
    if (this.is(ACTIVE)) {
      this._phase = IDLE;
      this._onChange(this.get(), true);
      const anim = this.animation;
      each(anim.values, (node) => {
        node.done = true;
      });
      const onRestQueue = anim.onRest;
      if (onRestQueue.length) {
        anim.onRest = [anim.toValues ? noop : onRestQueue[0]];
        if (!anim.changed) {
          onRestQueue[0] = noop;
        }
        each(onRestQueue, (onRest) => onRest(cancel));
      }
    }
  }
};
function checkDisposed(spring, name) {
  if (spring.is(DISPOSED)) {
    throw Error('Cannot call "' + name + '" of disposed "' + spring.constructor.name + '" object');
  }
}
function coerceEventProp(prop, key) {
  return is.fun(prop) ? prop : key && prop ? prop[key] : void 0;
}
var checkFinishedOnRest = (onRest, spring) => {
  const {
    to: to2
  } = spring.animation;
  return onRest ? (cancel) => {
    if (cancel) {
      onRest(getCancelledResult(spring));
    } else {
      const goal = computeGoal(to2);
      const value = computeGoal(spring.get());
      const finished = isEqual(value, goal);
      onRest(getFinishedResult(spring, finished));
    }
  } : noop;
};
function createLoopUpdate(props, loop = props.loop, to2 = props.to) {
  let loopRet = callProp(loop);
  if (loopRet) {
    const overrides = loopRet !== true && inferTo(loopRet);
    const reverse = (overrides || props).reverse;
    const reset = !overrides || overrides.reset;
    return createUpdate(_extends(_extends({}, props), {}, {
      loop,
      default: false,
      to: !reverse || is.arr(to2) || is.fun(to2) ? to2 : void 0,
      from: reset ? props.from : void 0,
      reset
    }, overrides));
  }
}
function createUpdate(props) {
  const {
    to: to2,
    from
  } = props = inferTo(props);
  const keys = new Set();
  if (from) {
    findDefined(from, keys);
  } else {
    delete props.from;
  }
  if (is.obj(to2)) {
    findDefined(to2, keys);
  } else if (!to2) {
    delete props.to;
  }
  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}
function declareUpdate(props) {
  const update = createUpdate(props);
  if (is.und(update.default)) {
    update.default = getDefaultProps(update, [
      update.immediate === true && "immediate"
    ]);
  }
  return update;
}
function findDefined(values, keys) {
  each(values, (value, key) => value != null && keys.add(key));
}
var BATCHED_EVENTS = ["onStart", "onChange", "onRest"];
var nextId$1 = 1;
var Controller = class {
  constructor(props, flush2) {
    this.id = nextId$1++;
    this.springs = {};
    this.queue = [];
    this._flush = void 0;
    this._initialProps = void 0;
    this._phase = CREATED;
    this._lastAsyncId = 0;
    this._active = new Set();
    this._state = {
      pauseQueue: new Set(),
      resumeQueue: new Set()
    };
    this._events = {
      onStart: new Set(),
      onChange: new Set(),
      onRest: new Map()
    };
    this._onFrame = this._onFrame.bind(this);
    if (flush2) {
      this._flush = flush2;
    }
    if (props) {
      this.start(props);
    }
  }
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((spring) => spring.idle);
  }
  is(phase) {
    return this._phase == phase;
  }
  get() {
    const values = {};
    this.each((spring, key) => values[key] = spring.get());
    return values;
  }
  update(props) {
    if (props)
      this.queue.push(createUpdate(props));
    return this;
  }
  start(props) {
    const queue = props ? toArray(props).map(createUpdate) : this.queue;
    if (!props) {
      this.queue = [];
    }
    if (this._flush) {
      return this._flush(this, queue);
    }
    prepareKeys(this, queue);
    return flushUpdateQueue(this, queue);
  }
  stop(keys) {
    if (is.und(keys)) {
      this.each((spring) => spring.stop());
      cancelAsync(this._state, this._lastAsyncId);
    } else {
      const springs = this.springs;
      each(toArray(keys), (key) => springs[key].stop());
    }
    return this;
  }
  pause(keys) {
    if (is.und(keys)) {
      this.each((spring) => spring.pause());
    } else {
      const springs = this.springs;
      each(toArray(keys), (key) => springs[key].pause());
    }
    return this;
  }
  resume(keys) {
    if (is.und(keys)) {
      this.each((spring) => spring.resume());
    } else {
      const springs = this.springs;
      each(toArray(keys), (key) => springs[key].resume());
    }
    return this;
  }
  reset() {
    this.each((spring) => spring.reset());
    return this;
  }
  each(iterator) {
    each(this.springs, iterator);
  }
  dispose() {
    this._state.asyncTo = void 0;
    this.each((spring) => spring.dispose());
    this.springs = {};
  }
  _onFrame() {
    const {
      onStart,
      onChange,
      onRest
    } = this._events;
    const isActive = this._active.size > 0;
    if (isActive && this._phase != ACTIVE) {
      this._phase = ACTIVE;
      flush(onStart, (onStart2) => onStart2(this));
    }
    const values = (onChange.size || !isActive && onRest.size) && this.get();
    flush(onChange, (onChange2) => onChange2(values));
    if (!isActive) {
      this._phase = IDLE;
      flush(onRest, ([onRest2, result]) => {
        result.value = values;
        onRest2(result);
      });
    }
  }
  onParentChange(event) {
    if (event.type == "change") {
      this._active[event.idle ? "delete" : "add"](event.parent);
      frameLoop.onFrame(this._onFrame);
    }
  }
};
function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map((props) => flushUpdate(ctrl, props))).then((results) => getCombinedResult(ctrl, results));
}
function flushUpdate(ctrl, props, isLoop) {
  const {
    to: to2,
    loop,
    onRest
  } = props;
  if (loop) {
    props.loop = false;
  }
  const asyncTo = is.arr(to2) || is.fun(to2) ? to2 : void 0;
  if (asyncTo) {
    props.to = void 0;
    props.onRest = void 0;
  } else {
    each(BATCHED_EVENTS, (key) => {
      const handler = props[key];
      if (is.fun(handler)) {
        const queue = ctrl["_events"][key];
        if (queue instanceof Set) {
          props[key] = () => queue.add(handler);
        } else {
          props[key] = ({
            finished,
            cancelled
          }) => {
            const result = queue.get(handler);
            if (result) {
              if (!finished)
                result.finished = false;
              if (cancelled)
                result.cancelled = true;
            } else {
              queue.set(handler, {
                value: null,
                finished,
                cancelled
              });
            }
          };
        }
      }
    });
  }
  const keys = props.keys || Object.keys(ctrl.springs);
  const promises = keys.map((key) => ctrl.springs[key].start(props));
  const state = ctrl["_state"];
  if (asyncTo) {
    promises.push(scheduleProps(++ctrl["_lastAsyncId"], {
      props,
      state,
      actions: {
        pause: noop,
        resume: noop,
        start(props2, resolve) {
          props2.onRest = onRest;
          if (!props2.cancel) {
            resolve(runAsync(asyncTo, props2, state, ctrl));
          } else if (hasDefaultProp(props2, "cancel")) {
            cancelAsync(state, props2.callId);
          }
        }
      }
    }));
  } else if (!props.keys && props.cancel === true) {
    cancelAsync(state, ctrl["_lastAsyncId"]);
  }
  return Promise.all(promises).then((results) => {
    const result = getCombinedResult(ctrl, results);
    if (loop && result.finished && !(isLoop && result.noop)) {
      const nextProps = createLoopUpdate(props, loop, to2);
      if (nextProps) {
        prepareKeys(ctrl, [nextProps]);
        return flushUpdate(ctrl, nextProps, true);
      }
    }
    return result;
  });
}
function getSprings(ctrl, props) {
  const springs = _extends({}, ctrl.springs);
  if (props) {
    each(toArray(props), (props2) => {
      if (is.und(props2.keys)) {
        props2 = createUpdate(props2);
      }
      if (!is.obj(props2.to)) {
        props2 = _extends(_extends({}, props2), {}, {
          to: void 0
        });
      }
      prepareSprings(springs, props2, (key) => {
        return createSpring(key);
      });
    });
  }
  return springs;
}
function setSprings(ctrl, springs) {
  each(springs, (spring, key) => {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      spring.addChild(ctrl);
    }
  });
}
function createSpring(key, observer) {
  const spring = new SpringValue();
  spring.key = key;
  if (observer) {
    spring.addChild(observer);
  }
  return spring;
}
function prepareSprings(springs, props, create) {
  if (props.keys) {
    each(props.keys, (key) => {
      const spring = springs[key] || (springs[key] = create(key));
      spring["_prepareNode"](props);
    });
  }
}
function prepareKeys(ctrl, queue) {
  each(queue, (props) => {
    prepareSprings(ctrl.springs, props, (key) => {
      return createSpring(key, ctrl);
    });
  });
}
var ctx = createContext({});
var SpringContext = (_ref) => {
  let {
    children
  } = _ref, props = _objectWithoutPropertiesLoose(_ref, ["children"]);
  const inherited = useContext(ctx);
  props = useMemo(() => _extends(_extends({}, inherited), props), [inherited, props.pause, props.cancel, props.immediate, props.config]);
  const {
    Provider
  } = ctx;
  return /* @__PURE__ */ createElement2(Provider, {
    value: props
  }, children);
};
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;
var useSpringContext = () => useContext(ctx);
var SpringHandle = {
  create: (getControllers) => ({
    get controllers() {
      return getControllers();
    },
    update(props) {
      each(getControllers(), (ctrl, i) => {
        ctrl.update(getProps(props, i, ctrl));
      });
      return this;
    },
    async start(props) {
      const results = await Promise.all(getControllers().map((ctrl, i) => {
        const update = getProps(props, i, ctrl);
        return ctrl.start(update);
      }));
      return {
        value: results.map((result) => result.value),
        finished: results.every((result) => result.finished)
      };
    },
    stop: (keys) => each(getControllers(), (ctrl) => ctrl.stop(keys)),
    pause: (keys) => each(getControllers(), (ctrl) => ctrl.pause(keys)),
    resume: (keys) => each(getControllers(), (ctrl) => ctrl.resume(keys))
  })
};
function useSprings(length, props, deps) {
  const propsFn = is.fun(props) && props;
  if (propsFn && !deps)
    deps = [];
  const layoutId = useRef4(0);
  const forceUpdate = useForceUpdate();
  const [state] = useState3(() => ({
    ctrls: [],
    queue: [],
    flush(ctrl, updates2) {
      const springs2 = getSprings(ctrl, updates2);
      const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key) => !ctrl.springs[key]);
      return canFlushSync ? flushUpdateQueue(ctrl, updates2) : new Promise((resolve) => {
        setSprings(ctrl, springs2);
        state.queue.push(() => {
          resolve(flushUpdateQueue(ctrl, updates2));
        });
        forceUpdate();
      });
    }
  }));
  const refProp = useRef4();
  const ctrls = [...state.ctrls];
  const updates = [];
  const prevLength = usePrev(length) || 0;
  const disposed = ctrls.slice(length, prevLength);
  useMemo(() => {
    ctrls.length = length;
    declareUpdates(prevLength, length);
  }, [length]);
  useMemo(() => {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);
  function declareUpdates(startIndex, endIndex) {
    for (let i = startIndex; i < endIndex; i++) {
      const ctrl = ctrls[i] || (ctrls[i] = new Controller(null, state.flush));
      let update = propsFn ? propsFn(i, ctrl) : props[i];
      if (update) {
        update = updates[i] = declareUpdate(update);
        if (i == 0) {
          refProp.current = update.ref;
          update.ref = void 0;
        }
      }
    }
  }
  const api = useMemo$1(() => {
    return SpringHandle.create(() => state.ctrls);
  }, []);
  const springs = ctrls.map((ctrl, i) => getSprings(ctrl, updates[i]));
  const context = useSpringContext();
  useLayoutEffect2(() => {
    layoutId.current++;
    state.ctrls = ctrls;
    if (refProp.current) {
      refProp.current.current = api;
    }
    const {
      queue
    } = state;
    if (queue.length) {
      state.queue = [];
      each(queue, (cb) => cb());
    }
    each(disposed, (ctrl) => ctrl.dispose());
    each(ctrls, (ctrl, i) => {
      const values2 = springs[i];
      setSprings(ctrl, values2);
      ctrl.start({
        default: context
      });
      const update = updates[i];
      if (update) {
        if (refProp.current) {
          ctrl.queue.push(update);
        } else {
          ctrl.start(update);
        }
      }
    });
  });
  useOnce(() => () => {
    each(state.ctrls, (ctrl) => ctrl.dispose());
  });
  const values = springs.map((x) => _extends({}, x));
  return propsFn || arguments.length == 3 ? [values, api.start, api.stop] : values;
}
function useSpring(props, deps) {
  const isFn = is.fun(props);
  const [[values], update, stop] = useSprings(1, isFn ? props : [props], isFn ? deps || [] : deps);
  return isFn || arguments.length == 2 ? [values, update, stop] : values;
}
function useTrail(length, propsArg, deps) {
  const propsFn = is.fun(propsArg) && propsArg;
  if (propsFn && !deps)
    deps = [];
  const ctrls = [];
  const result = useSprings(length, (i, ctrl) => {
    ctrls[i] = ctrl;
    return getProps(propsArg, i, ctrl);
  }, deps || [{}]);
  useLayoutEffect2(() => {
    const reverse = is.obj(propsArg) && propsArg.reverse;
    for (let i = 0; i < ctrls.length; i++) {
      const parent = ctrls[i + (reverse ? 1 : -1)];
      if (parent)
        ctrls[i].update({
          to: parent.springs
        }).start();
    }
  }, deps);
  if (propsFn || arguments.length == 3) {
    const update = result[1];
    result[1] = useCallbackOne((propsArg2) => {
      const reverse = is.obj(propsArg2) && propsArg2.reverse;
      return update((i, ctrl) => {
        const props = getProps(propsArg2, i, ctrl);
        const parent = ctrls[i + (reverse ? 1 : -1)];
        if (parent)
          props.to = parent.springs;
        return props;
      });
    }, deps);
    return result;
  }
  return result[0];
}
var MOUNT = "mount";
var ENTER = "enter";
var UPDATE = "update";
var LEAVE = "leave";
function useTransition(data, props, deps) {
  const {
    ref,
    reset,
    sort,
    trail = 0,
    expires = true
  } = props;
  const items = toArray(data);
  const transitions = [];
  const keys = getKeys(items, props);
  const usedTransitions = useRef4(null);
  const prevTransitions = reset ? null : usedTransitions.current;
  useLayoutEffect2(() => {
    usedTransitions.current = transitions;
  });
  useOnce(() => () => each(usedTransitions.current, (t) => {
    if (t.expired) {
      clearTimeout(t.expirationId);
    }
    t.ctrl.dispose();
  }));
  const reused = [];
  if (prevTransitions)
    each(prevTransitions, (t, i) => {
      if (t.expired) {
        clearTimeout(t.expirationId);
      } else {
        i = reused[i] = keys.indexOf(t.key);
        if (~i)
          transitions[i] = t;
      }
    });
  each(items, (item, i) => {
    transitions[i] || (transitions[i] = {
      key: keys[i],
      item,
      phase: MOUNT,
      ctrl: new Controller()
    });
  });
  if (reused.length) {
    let i = -1;
    each(reused, (keyIndex, prevIndex) => {
      const t = prevTransitions[prevIndex];
      if (~keyIndex) {
        i = transitions.indexOf(t);
        transitions[i] = _extends(_extends({}, t), {}, {
          item: items[keyIndex]
        });
      } else if (props.leave) {
        transitions.splice(++i, 0, t);
      }
    });
  }
  if (is.fun(sort)) {
    transitions.sort((a, b) => sort(a.item, b.item));
  }
  let delay = -trail;
  const forceUpdate = useForceUpdate();
  const defaultProps = getDefaultProps(props);
  const changes = new Map();
  each(transitions, (t, i) => {
    const key = t.key;
    const prevPhase = t.phase;
    let to2;
    let phase;
    if (prevPhase == MOUNT) {
      to2 = props.enter;
      phase = ENTER;
    } else {
      const isLeave = keys.indexOf(key) < 0;
      if (prevPhase != LEAVE) {
        if (isLeave) {
          to2 = props.leave;
          phase = LEAVE;
        } else if (to2 = props.update) {
          phase = UPDATE;
        } else
          return;
      } else if (!isLeave) {
        to2 = props.enter;
        phase = ENTER;
      } else
        return;
    }
    to2 = callProp(to2, t.item, i);
    to2 = is.obj(to2) ? inferTo(to2) : {
      to: to2
    };
    if (!to2.config) {
      const config2 = props.config || defaultProps.config;
      to2.config = callProp(config2, t.item, i);
    }
    const payload = _extends(_extends({}, defaultProps), {}, {
      delay: delay += trail,
      reset: false
    }, to2);
    if (phase == ENTER && is.und(payload.from)) {
      const from = is.und(props.initial) || prevTransitions ? props.from : props.initial;
      payload.from = callProp(from, t.item, i);
    }
    const {
      onRest
    } = payload;
    payload.onRest = (result) => {
      const transitions2 = usedTransitions.current;
      const t2 = transitions2.find((t3) => t3.key === key);
      if (!t2)
        return;
      if (is.fun(onRest)) {
        onRest(result, t2);
      }
      if (result.cancelled && t2.phase != UPDATE) {
        t2.phase = prevPhase;
        return;
      }
      if (t2.ctrl.idle) {
        const idle = transitions2.every((t3) => t3.ctrl.idle);
        if (t2.phase == LEAVE) {
          const expiry = callProp(expires, t2.item);
          if (expiry !== false) {
            const expiryMs = expiry === true ? 0 : expiry;
            t2.expired = true;
            if (!idle && expiryMs > 0) {
              if (expiryMs <= 2147483647)
                t2.expirationId = setTimeout(forceUpdate, expiryMs);
              return;
            }
          }
        }
        if (idle && transitions2.some((t3) => t3.expired)) {
          forceUpdate();
        }
      }
    };
    const springs = getSprings(t.ctrl, payload);
    changes.set(t, {
      phase,
      springs,
      payload
    });
  });
  const context = useSpringContext();
  useLayoutEffect2(() => {
    each(transitions, (t) => {
      t.ctrl.start({
        default: context
      });
    });
  }, [context]);
  const api = useMemo$1(() => {
    return SpringHandle.create(() => {
      return usedTransitions.current.map((t) => t.ctrl);
    });
  }, []);
  useImperativeHandle(ref, () => api);
  useLayoutEffect2(() => {
    each(changes, ({
      phase,
      springs,
      payload
    }, t) => {
      setSprings(t.ctrl, springs);
      if (!context.cancel) {
        t.phase = phase;
        if (phase == ENTER) {
          t.ctrl.start({
            default: context
          });
        }
        t.ctrl[ref ? "update" : "start"](payload);
      }
    });
  }, reset ? void 0 : deps);
  const renderTransitions = (render) => /* @__PURE__ */ createElement2(Fragment, null, transitions.map((t, i) => {
    const {
      springs
    } = changes.get(t) || t.ctrl;
    const elem = render(_extends({}, springs), t.item, t, i);
    return elem && elem.type ? /* @__PURE__ */ createElement2(elem.type, _extends({}, elem.props, {
      key: is.str(t.key) || is.num(t.key) ? t.key : t.ctrl.id,
      ref: elem.ref
    })) : elem;
  }));
  return arguments.length == 3 ? [renderTransitions, api.start, api.stop] : renderTransitions;
}
function getKeys(items, {
  key,
  keys = key
}) {
  return is.und(keys) ? items : is.fun(keys) ? items.map(keys) : toArray(keys);
}
var Interpolation = class extends FrameValue {
  constructor(source, args) {
    super();
    this.source = source;
    this.key = void 0;
    this.idle = true;
    this.calc = void 0;
    this.calc = createInterpolator(...args);
    const value = this._get();
    const nodeType = is.arr(value) ? AnimatedArray : AnimatedValue;
    setAnimated(this, nodeType.create(value));
  }
  advance(_dt) {
    const value = this._get();
    const oldValue = this.get();
    if (!isEqual(value, oldValue)) {
      getAnimated(this).setValue(value);
      this._onChange(value, this.idle);
    }
  }
  _get() {
    const inputs = is.arr(this.source) ? this.source.map((node) => node.get()) : toArray(this.source.get());
    return this.calc(...inputs);
  }
  _reset() {
    each(getPayload(this), (node) => node.reset());
    super._reset();
  }
  _start() {
    this.idle = false;
    super._start();
    if (skipAnimation) {
      this.idle = true;
      this.advance();
    } else {
      frameLoop.start(this);
    }
  }
  _attach() {
    let idle = true;
    let priority = 1;
    each(toArray(this.source), (source) => {
      if (isFrameValue(source)) {
        if (!source.idle)
          idle = false;
        priority = Math.max(priority, source.priority + 1);
      }
      source.addChild(this);
    });
    this.priority = priority;
    if (!idle) {
      this._reset();
      this._start();
    }
  }
  _detach() {
    each(toArray(this.source), (source) => {
      source.removeChild(this);
    });
    this.idle = true;
  }
  onParentChange(event) {
    if (event.type == "start") {
      this.advance();
    } else if (event.type == "change") {
      if (this.idle) {
        this.advance();
      } else if (event.idle) {
        this.idle = toArray(this.source).every((source) => source.idle !== false);
        if (this.idle) {
          this.advance();
          each(getPayload(this), (node) => {
            node.done = true;
          });
        }
      }
    } else if (event.type == "priority") {
      this.priority = toArray(this.source).reduce((max, source) => Math.max(max, (source.priority || 0) + 1), 0);
    }
    super.onParentChange(event);
  }
};
var interpolate2 = (source, ...args) => (deprecateInterpolate(), new Interpolation(source, args));
globals_exports.assign({
  createStringInterpolator: createStringInterpolator2,
  to: (source, args) => new Interpolation(source, args)
});

// ../../../node_modules/@react-spring/web/index.js
import {unstable_batchedUpdates} from "react-dom";

// ../../../node_modules/@react-spring/shared/esm/colors.js
var colors = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
};
var colors_default = colors;

// ../../../node_modules/@react-spring/web/index.js
var isCustomPropRE = /^--/;
function dangerousStyleValue(name, value) {
  if (value == null || typeof value === "boolean" || value === "")
    return "";
  if (typeof value === "number" && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]))
    return value + "px";
  return ("" + value).trim();
}
var attributeCache = {};
function applyAnimatedValues(instance, props) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }
  const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
  const _ref = props, {
    style,
    children,
    scrollTop,
    scrollLeft
  } = _ref, attributes = _objectWithoutPropertiesLoose(_ref, ["style", "children", "scrollTop", "scrollLeft"]);
  const values = Object.values(attributes);
  const names = Object.keys(attributes).map((name) => isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, (n) => "-" + n.toLowerCase())));
  globals_exports.frameLoop.onWrite(() => {
    if (children !== void 0) {
      instance.textContent = children;
    }
    for (let name in style) {
      if (style.hasOwnProperty(name)) {
        const value = dangerousStyleValue(name, style[name]);
        if (name === "float")
          name = "cssFloat";
        else if (isCustomPropRE.test(name)) {
          instance.style.setProperty(name, value);
        } else {
          instance.style[name] = value;
        }
      }
    }
    names.forEach((name, i) => {
      instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) {
      instance.scrollTop = scrollTop;
    }
    if (scrollLeft !== void 0) {
      instance.scrollLeft = scrollLeft;
    }
  });
}
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
var prefixKey = (prefix2, key) => prefix2 + key.charAt(0).toUpperCase() + key.substring(1);
var prefixes = ["Webkit", "Ms", "Moz", "O"];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes.forEach((prefix2) => acc[prefixKey(prefix2, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);
var domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var pxTransforms = /^(translate)/;
var degTransforms = /^(rotate|skew)/;
var addUnit = (value, unit) => is.num(value) && value !== 0 ? value + unit : value;
var isValueIdentity = (value, id) => is.arr(value) ? value.every((v) => isValueIdentity(v, id)) : is.num(value) ? value === id : parseFloat(value) === id;
var AnimatedStyle = class extends AnimatedObject {
  constructor(_ref) {
    let {
      x,
      y,
      z
    } = _ref, style = _objectWithoutPropertiesLoose(_ref, ["x", "y", "z"]);
    const inputs = [];
    const transforms = [];
    if (x || y || z) {
      inputs.push([x || 0, y || 0, z || 0]);
      transforms.push((xyz) => [
        "translate3d(" + xyz.map((v) => addUnit(v, "px")).join(",") + ")",
        isValueIdentity(xyz, 0)
      ]);
    }
    each(style, (value, key) => {
      if (key === "transform") {
        inputs.push([value || ""]);
        transforms.push((transform) => [transform, transform === ""]);
      } else if (domTransforms.test(key)) {
        delete style[key];
        if (is.und(value))
          return;
        const unit = pxTransforms.test(key) ? "px" : degTransforms.test(key) ? "deg" : "";
        inputs.push(toArray(value));
        transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg]) => ["rotate3d(" + x2 + "," + y2 + "," + z2 + "," + addUnit(deg, unit) + ")", isValueIdentity(deg, 0)] : (input) => [key + "(" + input.map((v) => addUnit(v, unit)).join(",") + ")", isValueIdentity(input, key.startsWith("scale") ? 1 : 0)]);
      }
    });
    if (inputs.length) {
      style.transform = new FluidTransform(inputs, transforms);
    }
    super(style);
  }
};
var FluidTransform = class extends FluidValue {
  constructor(inputs, transforms) {
    super();
    this.inputs = inputs;
    this.transforms = transforms;
    this._value = null;
    this._children = new Set();
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let transform = "";
    let identity = true;
    each(this.inputs, (input, i) => {
      const arg1 = getFluidValue(input[0]);
      const [t, id] = this.transforms[i](is.arr(arg1) ? arg1 : input.map(getFluidValue));
      transform += " " + t;
      identity = identity && id;
    });
    return identity ? "none" : transform;
  }
  addChild(child) {
    if (!this._children.size) {
      each(this.inputs, (input) => each(input, (value) => {
        const config2 = getFluidConfig(value);
        if (config2)
          config2.addChild(this);
      }));
    }
    this._children.add(child);
  }
  removeChild(child) {
    this._children.delete(child);
    if (!this._children.size) {
      each(this.inputs, (input) => each(input, (value) => {
        const config2 = getFluidConfig(value);
        if (config2)
          config2.removeChild(this);
      }));
    }
  }
  onParentChange(event) {
    if (event.type == "change") {
      this._value = null;
    }
    each(this._children, (child) => {
      child.onParentChange(event);
    });
  }
};
var primitives = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
globals_exports.assign({
  colorNames: colors_default,
  createStringInterpolator: createStringInterpolator2,
  batchedUpdates: unstable_batchedUpdates
});
var host = createHost(primitives, {
  applyAnimatedValues,
  createAnimatedStyle: (style) => new AnimatedStyle(style),
  getComponentProps: (_ref) => {
    let props = _objectWithoutPropertiesLoose(_ref, ["scrollTop", "scrollLeft"]);
    return props;
  }
});
var animated = host.animated;

// src/useReducedMotion.tsx
import {
  useEffect as useEffect4,
  useState as useState4
} from "react";
var REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
var isRenderingOnServer = (() => {
  if (typeof window == "undefined" || !window.location || !window.location.href || !window.matchMedia) {
    return true;
  }
  return Boolean(new URL(window.location.href).searchParams.get("eyes-storybook"));
})();
var getMediaQueryList = () => {
  if (isRenderingOnServer) {
    return {
      matches: true,
      addListener: () => {
      },
      removeListener: () => {
      }
    };
  }
  return window.matchMedia(REDUCED_MOTION_QUERY);
};
function useReducedMotion() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState4(getMediaQueryList().matches);
  useEffect4(() => {
    const mediaQueryList = getMediaQueryList();
    const handleChange = () => {
      setPrefersReducedMotion(mediaQueryList.matches);
    };
    mediaQueryList.addListener(handleChange);
    return () => {
      mediaQueryList.removeListener(handleChange);
    };
  }, []);
  return prefersReducedMotion;
}
export {
  globals_exports as Globals,
  animated,
  interpolate2 as interpolate,
  isRenderingOnServer,
  useChain,
  useReducedMotion,
  useSpring,
  useSprings,
  useTrail,
  useTransition
};
